import { api } from "../Configurations/axios";

const PutValueAvailability = async (id: string, value: number, userEmail: string, type: string, companyId: string) => {
    try {
        const result = await api.put('/Availability/PutValuesOnAvailability', { id: id, type: type, value: value, userEmail: userEmail, companyId: companyId });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    PutValueAvailability
}